import {
  CircularProgress,
  LinearProgress,
  Stack,
} from '@mui/material';
import React from 'react';
import { convertMinutesToTime } from 'utils/SecondsToMinutes';

const CircularDetermineProgress = ({ timer }) => {
  // const [initialTimer, setInitialTimer] = useState(100);

  // if (verificationTimer) {
  //   if (initialTimer !== 0) {
  //     setTimeout(() => {
  //       setInitialTimer(initialTimer - 1);
  //     }, 1800);
  //   } else {
  //     reset();
  //   }
  // }

  const minutes = convertMinutesToTime(timer);

  return (
    <React.Fragment>
      <Stack>
        <LinearProgress
          color="colorPrimer"
          variant="determinate"
          value={timer}
          sx={{ mt: '.2em' }}
        />
        <p>{minutes}</p>
      </Stack>
    </React.Fragment>
  );
};

export default CircularDetermineProgress;
